'use es6';

import { MARK_STAGED_PAGE_SETTINGS_SEEDED, SET_STAGED_PAGE_DATA } from 'page-editor-ui/redux/actions/actionTypes';
export const setStagedPageData = ({
  sandboxDomainName,
  liveDomainName,
  status,
  previewUrl
}) => ({
  type: SET_STAGED_PAGE_DATA,
  payload: {
    sandboxDomainName,
    liveDomainName,
    status,
    previewUrl
  }
});
export const markStagedPageSettingsSeeded = () => ({
  type: MARK_STAGED_PAGE_SETTINGS_SEEDED
});